<template>
  <footer class="site-footer">
    <div class="footer-container">
      <div class="footer-brand">
        <h3>GAMESNEST</h3>
        <p>THE ULTIMATE SOURCE FOR GAMING TRANSMISSIONS.</p>
      </div>
      <div class="footer-grid">
        <div class="footer-section">
          <h4>INTEL</h4>
          <ul>
            <li><a href="/news/">NEWS</a></li>
            <li><a href="/reviews/">REVIEWS</a></li>
            <li><a href="/guides/">GUIDES</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>MARKET</h4>
          <ul>
            <li><a href="/deals/">DEALS</a></li>
            <li><a href="/games/">GAMES</a></li>
            <li><a href="/platforms/">PLATFORMS</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>LEGAL</h4>
          <ul>
            <li><a href="/privacy-policy/">PRIVACY POLICY</a></li>
            <li><a href="/terms-of-service/">TERMS OF SERVICE</a></li>
            <li><a href="/cookie-policy/">COOKIE POLICY</a></li>
            <li><a href="/disclaimer/">DISCLAIMER</a></li>
            <li><a href="/about-us/">ABOUT US</a></li>
            <li><a href="/contact-us/">CONTACT US</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>FRIENDS</h4>
          <ul>
            <li>
              <a href="https://gamesving.com/" target="_blank" rel="noopener">GAMESVING</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-container">
        <p>&copy; 2026 GAMESNEST_SYS. ALL RIGHTS RESERVED.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="scss" scoped>
.site-footer {
  background-color: $bg-secondary;
  border-top: 4px solid $primary-color;
  margin-top: rem(64);
}

.footer-container {
  max-width: $container-max-width;
  margin: 0 auto;
  padding: rem(64) rem(24);
  display: grid;
  grid-template-columns: 1fr;
  gap: rem(48);

  @include pc {
    grid-template-columns: 1.2fr 1.8fr;
  }
}

.footer-brand {
  h3 {
    color: $text-primary;
    margin-bottom: rem(16);
    font-family: $font-family-heading;
    font-size: rem(48);
    font-weight: 900;
    letter-spacing: 2px;
  }

  p {
    color: $text-secondary;
    font-size: rem(16);
    font-family: $font-family-heading;
    letter-spacing: 1px;
    font-weight: 700;
  }
}

.footer-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: rem(32);

  @include pc {
    grid-template-columns: repeat(4, 1fr);
  }
}

.footer-section {
  h4 {
    margin-bottom: rem(24);
    color: $primary-color;
    font-size: rem(20);
    font-family: $font-family-heading;
    font-weight: 900;
    letter-spacing: 1px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: rem(12);
  }

  a {
    color: $text-secondary;
    font-size: rem(14);
    font-family: $font-family-heading;
    font-weight: 700;
    letter-spacing: 1px;
    transition: color $transition-speed, transform $transition-speed;
    display: inline-block;

    &:hover {
      color: $text-primary;
      transform: translateX(4px);
    }
  }
}

.footer-bottom {
  background-color: $bg-primary;
  border-top: 1px solid $border-color;
  padding: rem(24) 0;

  &-container {
    max-width: $container-max-width;
    margin: 0 auto;
    padding: 0 rem(24);
    text-align: center;

    @include pc {
      text-align: left;
    }
  }

  p {
    color: $text-muted;
    font-size: rem(12);
    font-family: $font-family-heading;
    letter-spacing: 1px;
    margin: 0;
  }
}
</style>
